import { TrackingEvent } from '@y42/core/user-tracking';

export class OrgSpaceSelectedTrackingEvent extends TrackingEvent {
  readonly name = 'Space Selected';
}
